module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/gold-buyin-button-hover.06748034.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/gold-buyin-button-hover.png
// module id = 2990
// module chunks = 11